import { createSlice } from '@reduxjs/toolkit';

import { balanceApi } from 'api/balance-api';
import { Invoice } from 'types/api/api-balance.types';

export type InvoicesSliceType = {
  invoices: Invoice[] | [];
};

export const initialState: InvoicesSliceType = {
  invoices: [],
};

// Populated via extraReducers on the RTK Query fulfilled action (same pattern as
// features-slice): invoices are no longer fetched at app startup — InvoicesPage mounts
// useGetInvoicesQuery and the result lands here for every consumer.
const slice = createSlice({
  name: 'invoices',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addMatcher(balanceApi.endpoints.getInvoices.matchFulfilled, (state, action) => {
      state.invoices = action.payload;
    });
  },
});

export default slice.reducer;
// selectors
export const invoicesSelector = (state: { invoices: InvoicesSliceType }) => state.invoices;
